import React from 'react';
import { Spinner, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Button from '../../../../components/molecules/buttons';
import {
  ArrowLeft, Delete, Pencil, User,
} from '../../../../components/atoms/icons';
import Forms from '../../../../components/molecules/forms';
import useModelManagement from './hooks';
import RenderPagination from '../../../../components/molecules/pagination';
import Modal from '../../../../components/organisms/modals';
import { successUpdateMsg } from '../../../../components/atoms/const';

function ModelManagement() {
  const {
    model, page, search, configDelete, navigation,
  } = useModelManagement();
  const classNameHeader = React.useMemo(
    () => 'color-placeholder fw-bold border-color-stroke border-bottom fw-normal fz-14',
    [],
  );
  const renderModalBodyDelete = React.useMemo(() => {
    if (!configDelete.result) return 'Are you sure to remove this model configuration?';
    return successUpdateMsg.SUCCESS_DELETE_MODEL_CONFIG_MSG;
  }, [configDelete.result]);
  return (
    <div className="px-4 px-xl-5 py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div className="d-flex align-items-center">
          <Link to="/vending-machine">
            <ArrowLeft />
          </Link>
          <h4 className="fw-bold ms-2" style={{ marginTop: '11px' }}>Model Management</h4>
        </div>
        <Button.CircleIcon id="userCircleIcon" icon={<User width={23} />} type="button" />
      </div>
      <div className="d-flex justify-content-between mb-4" style={{ height: '42px' }}>
        <div style={{ maxWidth: '500px' }} className="h-100 w-100 me-2">
          <Forms.Search
            value={search.current}
            onChange={(e) => search.setCurrent(e.target.value)}
            placeholder="Search..."
          />
        </div>
        <div style={{ width: '200px' }}>
          <Button.Default
            id="addConfiguration"
            type="button"
            label="Add Configuration"
            onClick={navigation.add}
          />
        </div>
      </div>
      <div
        className="border border-1 border-color-stroke w-100 mb-4 d-flex flex-column py-2"
        style={{ borderRadius: '20px' }}
      >
        <Table borderless responsive>
          <thead>
            <tr>
              <th className={`${classNameHeader} ps-4 ps-xl-5`}><div className="my-2">NAME</div></th>
              <th className={classNameHeader}><div className="my-2">NUMBER OF CONFIGURATION</div></th>
              <th className={`${classNameHeader} pe-4 pe-xl-5 text-end`}><div className="my-2">ACTIONS</div></th>
            </tr>
          </thead>
          <tbody>
            {(() => {
              if (model.load) {
                return (
                  <tr>
                    <td colSpan={3}>
                      <div className="d-flex justify-content-center"><Spinner animation="border" size="sm" /></div>
                    </td>
                  </tr>
                );
              } if (!!model.list && model.list.length > 0) {
                return model.list?.map((data, i) => (
                  <tr
                    key={data.id}
                    className={`${i % 2 === 0 ? '' : 'bg-solid'} 
                    ${i === (model.list?.length ?? 1) - 1 ? 'border-color-stroke border-bottom' : ''} align-middle`}
                  >
                    <td className="fz-14 ps-4 ps-xl-5"><div className="my-2">{data.model}</div></td>
                    <td className="fz-14"><div className="my-2">{data.numberOfConfigurations}</div></td>
                    <td className="fz-14 pe-4 pe-xl-5">
                      <div className="d-flex justify-content-end align-items-center my-2">
                        <Modal.Default
                          cancelLabel="No"
                          submitLabel="Yes"
                          title="Delete Configuration"
                          isLoading={configDelete.load}
                          onSubmit={() => configDelete.handler(data.id)}
                          result={configDelete.result}
                          body={renderModalBodyDelete}
                          onAfterResult={configDelete.after}
                        >
                          <div className="me-3">
                            <Delete />
                          </div>
                        </Modal.Default>
                        <Link to={`/vending-machine/model-management/${data.id}`} style={{ marginTop: '2px' }}>
                          <Pencil />
                        </Link>
                      </div>
                    </td>
                  </tr>
                ));
              }
              return (
                <tr>
                  <td colSpan={3}>
                    <div className="text-center">Data Not Found</div>
                  </td>
                </tr>
              );
            })()}
          </tbody>
        </Table>
        <div className="d-flex justify-content-md-end justify-content-center mt-4 w-100 px-4 px-xl-5">
          <RenderPagination
            currentPage={page.current}
            setCurrentPage={page.setCurrent}
            totalPage={model.totalPage}
          />
        </div>
      </div>
    </div>
  );
}

export default ModelManagement;
